import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { TechRadarCegidClient } from './lib/TechRadarCegidClient';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { ApiDefinitionWidget, apiDocsConfigRef, defaultDefinitionWidgets } from '@backstage/plugin-api-docs';
import { ApiEntity } from '@backstage/catalog-model';
import {
  extractOpenApiClientIdAnnotation,
  extractOpenApiScopesAnnotation,
  hasCustomAnnotations,
  CustomOpenApiDefinitionWidget
} from './components/api-docs';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory(
    techRadarApiRef,
    new TechRadarCegidClient(),
  ),
  createApiFactory({
    api: apiDocsConfigRef,
    deps: {},
    factory: () => {
      const definitionWidgets = defaultDefinitionWidgets();
      return {
        getApiDefinitionWidget: (apiEntity: ApiEntity) => {
          const isVerify = hasCustomAnnotations(apiEntity);
          if (isVerify) {
            return {
              type: 'openapi',
              title: 'OpenAPI',
              rawLanguage: 'yaml',
              component: definition => <CustomOpenApiDefinitionWidget definition={definition} oauth={
                {
                  clientId: extractOpenApiClientIdAnnotation(apiEntity),
                  scopes: extractOpenApiScopesAnnotation(apiEntity),
                }
              } />,
            } as ApiDefinitionWidget;
          }
          // fallback to the defaults
          return definitionWidgets.find(d => d.type === apiEntity.spec.type);
        },
      };
    },
  }),
  ScmAuth.createDefaultApiFactory(),
];
